import {useAuth} from "base/auth";

const EditorHiddenAuth = ({children}) => {
    const {ROLES, hasRole} = useAuth();

    return !hasRole(ROLES.EDITOR) && !hasRole(ROLES.CONCELLO) && !hasRole(ROLES.SUPRAMUNICIPAL) ? <>{children}</> : null;
};

export default EditorHiddenAuth;
